export function getUnitTypeColumnIndex<T>(
  checkIsUnitVolumeColumn: (column: T) => boolean,
  columns: T[],
) {
  const index = columns.findIndex(checkIsUnitVolumeColumn);
  return index !== -1 ? index : null;
}
